import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux';
import { Link, NavLink, useNavigate } from 'react-router-dom'
import LogoAnimationLoader from '../components/Loading/LogoAnimationLoader';

import AdminUserService from '../api/services/AdminUserService'
import logo from '../../images/logo/logo-full.png';
import LogoWhite from '../../images/logo/logofull-white.png';
import camporLogo from '../../images/logo/Born-To-Camp.png';
import bg6 from '../../images/background/bg6.jpg';
import bg1 from '../../images/background/bg1.jpg';

function Login(props) {

	const navigate = useNavigate();
	const [email, setEmail] = useState('');
	let errorsObj = { email: '', password: '' };
	const [errors, setErrors] = useState(errorsObj);
	const [Error, setError] = useState('');
	const [isLoading, setisloading] = useState(false);
	const [password, setPassword] = useState('');
	useEffect(() => {


		if (localStorage.getItem("admintoken")) {

			navigate('/current-pickups-returns')
			setisloading(true)
		}
		

	}, [])

	const onLogin = async (event) => {
		event.preventDefault();
		try {
			var userData = {
				email: event.target.email.value,
				password: event.target.password.value,
				device_name: "web"
			}
			if (event.target.email.value === '') {
				setError('The email field is required')
			}
			else if (event.target.password.value === '') {
				setError("The password field is required")
			}
			else {
				const response = await AdminUserService.login(userData).json();
				
				localStorage.setItem("user", JSON.stringify(response.user));

				localStorage.setItem("admintoken", JSON.stringify(response.idToken));

				// const userRole = response?.user?.roles?.map((data) => {
				// 	return data?.name;
				// }) || [];

				// if (userRole.includes("Admin")){
				// 	navigate('/dashboard')
				// }else{
				// 	navigate('/current-pickups-returns')
				// }
                navigate('/current-pickups-returns')

				
			}

		}
		catch (error) {
			if (error.name === 'HTTPError') {
				const errorJson = await error.response.json();

				setError(errorJson.message.substr(0, errorJson.message.lastIndexOf(".")))
			}
			
		}

	}



	return (
		<>
			{isLoading === true ?
				<LogoAnimationLoader /> :
				<div className="page-wraper">
					<div className="browse-job login-style3">
						<div className="bg-img-fix overflow-hidden" style={{ background: '#fff url(' + bg1 + ')', height: "100vh", backgroundSize: "100%", backgroundPosition: "100%" }}>
							<div className="row gx-0">
								<div className="col-xl-4 col-lg-5 col-md-6 col-sm-12 vh-100 bg-white ">
									<div id="mCSB_1" className="mCustomScrollBox mCS-light mCSB_vertical mCSB_inside" style={{ maxHeight: "653px" }}>
										<div id="mCSB_1_container" className="mCSB_container" style={{ position: "relative", top: "0", left: "0", dir: "ltr" }}>
											<div className="login-form style-2">
												<div className="card-body">
													<div className="logo-header">
														<Link to={"#"} className="logo">
															<img src={camporLogo} alt="" className="width-230 light-logo" style={{ width: "100%", maxWidth: "200px" }} />
														</Link>
														{/* <Link to={"#"} className="logo"><img src={LogoWhite} alt="" className="width-230 dark-logo" /></Link> */}
													</div>
													<div className="nav nav-tabs border-bottom-0" >
														<div className="tab-content w-100" id="nav-tabContent">
															<div className="tab-pane fade active show" id="nav-personal">

																<form className=" dz-form pb-3" onSubmit={onLogin}>
																	<h3 className="form-title m-t0">Personal Information</h3>
																	<div className="dz-separator-outer m-b5">
																		<div className="dz-separator bg-primary style-liner"></div>
																	</div>
																	<p>Enter your e-mail address and your password. </p>
																	<div className="form-group mb-3">

																		<input type="email" className="form-control" name='email' onChange={(e) => setEmail(e.target.value)} />

																	</div>
																	<div className="form-group mb-3">

																		<input type="password" className="form-control" name='password' />

																	</div>
																	<h5 style={{ color: 'red' }}>{Error}</h5>
																	<div className="form-group text-left mb-5">
																		<button type="submit" className="btn btn-primary dz-xs-flex m-r5">login</button>
																	
																	</div>
																	
																</form>
																
															</div>

														</div>
													</div>
												</div>
												
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			}


		</>
	)

}

const mapStateToProps = (state) => {
	return {
		errorMessage: state.auth.errorMessage,
		successMessage: state.auth.successMessage,
		showLoading: state.auth.showLoading,
	};
};
export default connect(mapStateToProps)(Login);